/* A single lifecycle for card hover, arrows, touch swipes and media state. */
(() => {
  if (window.ArnavProductCard) return;
  const ready = new WeakSet();
  function go(card, index) {
    const track = card.querySelector('.card-image-track');
    if (!track) return;
    const slides = [...track.children], total = slides.length;
    if (!total) return;
    const current = window.ArnavCarousel.move(track, index);
    card.classList.toggle('is-active-slide', current !== 0);
    const progress = card.querySelector('.card-progress-bar');
    if (progress) progress.style.transform = `translateX(${current * 100}%)`;
    slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', String(i !== current));
      const video = slide.querySelector('video');
      if (video) { if (i === current) video.play().catch(() => {}); else video.pause(); }
    });
  }
  function init(root = document) {
    root.querySelectorAll('[data-arnav-card]').forEach(card => {
      if (ready.has(card)) return;
      ready.add(card);
      go(card, 0);
      let start = null, suppressClick = false;
      const index = () => Number(card.querySelector('.card-image-track').dataset.currentSlide || 0);
      card.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches && card.dataset.secondary !== 'false') go(card, 1); });
      card.addEventListener('mouseleave', () => go(card, 0));
      card.addEventListener('click', e => {
        const button = e.target.closest('.card-slider-nav');
        if (button || suppressClick) { e.preventDefault(); e.stopPropagation(); }
        if (button) go(card, index() + (button.classList.contains('next-btn') ? 1 : -1));
        suppressClick = false;
      }, true);
      card.addEventListener('pointerdown', e => { if (!e.target.closest('button')) { start = {x:e.clientX,y:e.clientY}; suppressClick = false; } });
      card.addEventListener('pointerup', e => {
        if (!start) return;
        const dx = e.clientX-start.x, dy=e.clientY-start.y;
        if (Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) { go(card,index()+(dx<0?1:-1)); suppressClick=true; }
        start=null;
      });
      card.addEventListener('pointercancel', () => { start=null; suppressClick=false; });
      card.addEventListener('dragstart', e => e.preventDefault());
    });
  }
  window.ArnavProductCard = {init, go};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
